"use strict";
import { __require as f } from "./index.es327.js";
import { __require as u } from "./index.es317.js";
var o, n;
function d() {
  if (n) return o;
  n = 1;
  var _ = f(), i = /* @__PURE__ */ u(), p;
  try {
    p = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (r) {
    if (!r || typeof r != "object" || !("code" in r) || r.code !== "ERR_PROTO_ACCESS")
      throw r;
  }
  var e = !!p && i && i(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), a = Object, c = a.getPrototypeOf;
  return o = e && typeof e.get == "function" ? _([e.get]) : typeof c == "function" ? (
    /** @type {import('./get')} */
    function(t) {
      return c(t == null ? t : a(t));
    }
  ) : !1, o;
}
export {
  d as __require
};
//# sourceMappingURL=index.es404.js.map
